/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

import { MSAL_INSTANCE } from '@azure/msal-angular';
import { IPublicClientApplication } from '@azure/msal-browser';

bootstrapApplication(AppComponent, appConfig).then(appRef => {
    // Obtener la instancia configurada en app.config.ts
    const msalInstance = appRef.injector.get<IPublicClientApplication>(MSAL_INSTANCE);

    // Inicializar MSAL antes de usar acquireTokenSilent
    msalInstance.initialize()
        .then(() => {
            console.log("✅ MSAL inicializado correctamente");
        })
        .catch((err: unknown) => {
            console.error("❌ Error al inicializar MSAL", err);
        });
});